import * as $ from 'jquery';
import 'bootstrap';
import 'cookieconsent';
import { headerContent } from './c002';

declare global {
	interface Window { cookieconsent: any; }
}

window.cookieconsent = window.cookieconsent || {};

export class pdpaOverlay{
	private headercontent = new headerContent();

  pdpaCookie(): any{
    /* Start - Cookie consent */
    let _self = this;
    let $pdpaActive: any = $('.pdpa-overlay');
    let $mabCookieConsent: any = $('.mab-cookie--consent');
    let dataCookieMessage: any = $mabCookieConsent.attr('data-message');
    let dataCookieDismiss: any = $mabCookieConsent.attr('data-dismiss');
    let dataCookieLearnmore: any = $mabCookieConsent.attr('data-learnmore');
    let dataCookieLink: any = $mabCookieConsent.attr('data-link');

    window.addEventListener("load", function(){
      if($pdpaActive.length > 0){
        window.cookieconsent.initialise({
          "palette": {
            "popup": {
              "background": "#14467B"
            },
            "button": {
              "background": "#006DBB"
            }
          },
          "position": "top",
          "content": {
            "message": dataCookieMessage,
            "dismiss": dataCookieDismiss,
            "link": dataCookieLearnmore,
            "href": dataCookieLink
          },
          onPopupOpen: function() {
			      _self.headercontent.calcMainnavOffset();
          },
          onPopupClose: function(){
          	setTimeout(() => {
          		_self.headercontent.calcMainnavOffset();
          	}, 1800);
          	$pdpaActive.parent().parent().hide();
          }
        });
        let $dataCookieMessage: any = $('.cc-window .cc-message a');
        if($mabCookieConsent.hasClass('self')){
          $dataCookieMessage.attr('target','_self');
        } else {
          $dataCookieMessage.attr('target','_blank');
        }
      }
    });
    /* End - Cookie consent */
  }
}

try {
	let pdpaoverlay = new pdpaOverlay();
  if (window.location.search.indexOf('checkin=true') > -1) {
	} else {
  	pdpaoverlay.pdpaCookie();
  }
} catch(e) {console.error(e);}
